import axios from 'axios';

export default {
    namespaced: true,

    actions: {
        // 所属コード変換情報取得API
        async getConversionData({ state, commit, rootState }: any, data: any) {
            // 通信結果
            let result: any;

            // 所属コード変換情報をback側から取得
            // URL:GET /api/affiliation-code-conversion
            // params:ページ番号
            //        １ページあたりの行数
            //        ソートキー
            //        ソート順
            //        フィルタ情報
            //        初期表示フラグ（true: 初期表示, false: テーブル更新）
            await axios.get('/api/affiliation-code-conversion', {
                params: {
                    page: data.page,
                    itemsPerPage: data.itemsPerPage,
                    sortKey : data.sortKey,
                    sortOrder : data.sortOrder,
                    filterParams : data.filterParams,
                    isInitial: data.isInitial
                }
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // アップロードファイルのファイル件数, 最大サイズ, 拡張子の取得API
        async getParameters() {
            // 通信結果の初期化
            let result: any;

            // ファイルバリデーション情報を取得
            // URL:GET /api/affiliation-code-conversion/parameter
            // params: なし
            await axios.get('/api/affiliation-code-conversion/parameter')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 所属コード変換ファイル取込API
        async importFileData({ state, commit, rootState }: any, data: any) {
            // 通信結果の初期化
            let result: any;

            const formData = new FormData();

            // formData に所属コード変換ファイルを設定する
            data.file.forEach((e: any) => {
                if (e instanceof File) {
                    formData.append('file', e, e.name);
                }
            });

            // URL:POST /api/affiliation-code-conversion/file-import
            // params: formData（ファイル取込ダイアログに設定したファイル）
            await axios.post('/api/affiliation-code-conversion/file-import', formData)
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 所属コード変換先組織情報取得API
        async getOrganizationPullDown() {
            // 通信結果
            let result: any;

            // 所属コード変換先組織情報を取得
            // URL:GET /api/affiliation-code-conversion/pulldown
            // params: なし
            await axios.get('/api/affiliation-code-conversion/pulldown')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 所属コード変換先組織更新API
        async updateOrganization({ state, commit, rootState }: any, data: any) {
            // 通信結果
            let result: any;

            // 所属コード変換先組織を更新
            // URL: PUT /api/affiliation-code-conversion/after-organization
            // params: 変換元所属コード
            //         変換先組織ID
            await axios.put('/api/affiliation-code-conversion/after-organization',
                {
                    beforeAffiliationCode: data.beforeAffiliationCode,
                    afterOrganizationId: data.selectOrgId
                })
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 所属コード変換情報削除API
        async deleteConversionData({ state, commit, rootState }: any, data: any) {
            // 通信結果
            let result: any;

            // 所属コード変換情報を削除
            // URL: DELETE /api/affiliation-code-conversion
            // params: 変換元所属コード
            await axios.delete('/api/affiliation-code-conversion', {
                params: {
                    beforeAffiliationCode: data.beforeAffiliationCode
                }
            })
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 所属コード変換処理実行API
        async addConversionData() {
            // 通信結果
            let result: any;

            // 所属コード変換処理を実行
            // URL: GET /api/affiliation-code-conversion/data-conversion
            // params: なし
            await axios.get('/api/affiliation-code-conversion/data-conversion')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        }
    }
}
